import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const ChevronRight = createIcon({
  displayName: "ChevronRight",
  viewBox: "0 0 24 24",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Chevron Right Icon </title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83328 4.61617C8.63788 4.42104 8.3213 4.42127 8.12618 4.61667C7.93105 4.81207 7.93128 5.12865 8.12668 5.32378L14.8124 12L8.12668 18.6762C7.93128 18.8713 7.93105 19.1879 8.12618 19.3833C8.3213 19.5787 8.63788 19.5789 8.83328 19.3838L15.8733 12.3538C15.9467 12.2804 15.9926 12.1899 16.0109 12.0951C16.0252 12.0208 16.0226 11.9438 16.003 11.8704C15.981 11.7882 15.9378 11.7106 15.8733 11.6462L8.83328 4.61617Z"
      />
    </>
  )
});
